import { KeycloakService } from 'keycloak-angular';
import { firstValueFrom, tap } from 'rxjs';
import { ConfigService } from '../../services/env-config.service';
import { HttpService } from '../../services/http.service';
export function keycloakInitService(
 keycloak: KeycloakService,
 configService: ConfigService,
 httpService: HttpService
): () => Promise<void> {
 return async (): Promise<void> => {
     const config: any = await firstValueFrom(
      configService.getConfig().pipe(
             tap((data: any) => {
                configService.baseUrl = data.baseUrl;
             }),
      ));
     if (config.disabledMFA || config.disabledMFA === 'undefined') {
       return Promise.resolve();
     }
     const ssoConfig = await firstValueFrom(
       httpService.getSsoConfiguration()
     );
     await keycloak.init({
       config: {
         url: ssoConfig.ssoUrl,
         realm: ssoConfig.ssoRealm,
         clientId: ssoConfig.ssoClientId,
       },
       initOptions: {
         onLoad: 'check-sso',
         silentCheckSsoRedirectUri: window.location.origin + '/public/silent-check-sso.html',
         checkLoginIframe: false,
       },
     }); 
   return;
 };
}